export default [
	{
		name: "appCheckBroker",
		path: "/appCheckBroker",
		meta: {
				layout: "BlankLayout",
				title: "Dot Apps",
		},
		component: () => import("@/view/AppCheckBroker.vue")
	},
	{
		name: "login",
		path: "/login",
		component: () => import("@/view/login/Login"),
		meta: { layout: "BlankLayout", leftMenu: "false" }
    },
	{
		name: "login-callback",
		path: "/login-callback",
		component: () => import("@/view/login/LoginCallback"),
		meta: { layout: "BlankLayout", leftMenu: "false" }
  }
]